const handleCopy = ({ setMessage, setSeverity, setIsToastTriggered, value, type }) => {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    const setMessageValue = () => {
        if (!type) return value;
        if (type === "cid") return "Client ID";
        if (type === "scopes") return "OAuth Scopes";
        return null;
    };
    const messageValue = setMessageValue();

    try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            navigator.clipboard
                .writeText(value)
                .then(() => {
                    setMessage(`Copied ${messageValue} to clipboard successfully`);
                    setSeverity("success");
                    setIsToastTriggered(true);
                })
                .catch(() => {
                    setMessage("Failed to copy value to clipboard");
                    setSeverity("success");
                    setIsToastTriggered(true);
                });
        } else {
            const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOSDevice) {
                const range = document.createRange();
                range.selectNodeContents(textarea);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                const successful = document.execCommand("copy");
                if (successful) {
                    setMessage(`Copied ${value} to clipboard successfully`);
                    setSeverity("success");
                    setIsToastTriggered(true);
                } else {
                    console.error(`Failed to copy ${value} to clipboard`);
                }
            } else {
                console.error("Copying to clipboard is not supported in this browser.");
            }
        }
    } catch (err) {
        console.error(`Unable to copy to clipboard: `, err);
    } finally {
        document.body.removeChild(textarea);
    }
};

export default handleCopy;
